export default {
  directoryProfiles: [],
};
